import constants from '../constants';
import type { AllActionTypes } from '../constants';
import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';

export type Actions = { type: AllActionTypes; payload: ZrmClickstreamUser };

const initialState = {
  isMultifamilyCustomer: false,
  isSingleFamilyEnterpriseCustomer: false,
  summary: {
    totalListingCount: 0,
    activeListingCount: 0,
    isPartialResponse: false,
  },
};
const user = (state: ZrmClickstreamUser = initialState, action: Actions): ZrmClickstreamUser => {
  switch (action.type) {
    case constants.INIT_USER:
      return action.payload;
    default:
      return state;
  }
};

export default user;
